import React from 'react';
import { TooltipWrapper, TooltipLabel, Tooltip } from './styled';

const MapTooltip = () => {
  return (
    <TooltipWrapper>
      <TooltipLabel>SafetyWing team map</TooltipLabel>
      <Tooltip>
        Many of us are nomads — this dynamic map is updated frequently by our members to
        reflect where we are working at any given time. If you’re lucky, you might get to
        see most (if not all!) of us in one exotic locale for a team gathering.
      </Tooltip>
    </TooltipWrapper>
  );
};

export default MapTooltip;
